import { uiConfig } from "./ui/uiConfig";
import { authConfig } from "./auth/authConfig";
import { adminConfig } from "./users/admin/adminConfig";
import { uiRoutes } from "../routes/ui/uiRoutes";
import HomePage from "./users/HomePage";
export const routeConfig = [
  ...uiConfig,
  ...authConfig,
  ...adminConfig,
  { path: uiRoutes.home, element: <HomePage /> },
];
